import React from "react";
import abimg from "../../../assets/images/about-gehl.webp";
import Hero from "./components/Hero/Hero";
import Presentation from "./components/Presentation/Presentation";
import ProjectSection from "./components/ProjectSection";
import ServiceSection from "./components/service/ServiceSection";
import TeamSection from "./components/TeamSection";
import Testimonial from "./components/Testimonial/Testimonial";

import "./Home.css";

const Home = () => {
  return (
    <>
      <Hero />
      <Presentation abimg={abimg} />
      <ProjectSection />
      <ServiceSection />
      <TeamSection />
      <Testimonial />
    </>
  );
};

export default Home;
